// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';

// // ✅ Async thunk (handles API + normalization)
// export const fetchRoles = createAsyncThunk(
//     'rolePermissions/fetchRoles',
//     async (_, thunkAPI) => {
//         try {
            
//             const { data } = await axios.get('/roles');
//             const roleMap = Object.fromEntries(
//                 data.map((r) => [
//                     r.roleName,
//                     {
//                         modules: r.modules,
//                         actions: r.actions,
//                         departments: r.departments,
//                         excludedModules: r.excludedModules || [],
//                         employees: r.employees || [],

//                     },
//                 ])
//             );

//             return roleMap;
//         } catch (err) {
//             return thunkAPI.rejectWithValue(err.response?.data || err.message);
//         }
//     }
// );

// const rolePermissionsSlice = createSlice({
//     name: 'rolePermissions',
//     initialState: {
//         entities: {}, // ✅ Use normalized data shape
//         loading: false,
//         error: null,
//     },
//     reducers: {
//         clearPermissions: (state) => {
//             state.entities = {};
//             state.error = null;
//         },
//     },
//     extraReducers: (builder) =>
//         builder
//             .addCase(fetchRoles.pending, (state) => {
//                 state.loading = true;
//             })
//             .addCase(fetchRoles.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.entities = action.payload;
//             })
//             .addCase(fetchRoles.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload;
//             }),
// });

// export const { clearPermissions } = rolePermissionsSlice.actions;
// export default rolePermissionsSlice.reducer;


import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// ✅ Async thunk (handles API + normalization)
export const fetchRoles = createAsyncThunk(
    'rolePermissions/fetchRoles',
    async (_, thunkAPI) => {
        try {
            const { data } = await axios.get('/roles');
            // Normalize to map by role.name (new schema key)
            const roleMap = Object.fromEntries(
                data.map((r) => [
                    r.name, // New: use 'name' instead of 'roleName'
                    {
                        permissions: r.permissions, // New: Map of module -> actions
                        customPermissions: r.customPermissions || new Map(), // New: Map of userId -> module overrides
                        departments: r.departments || [],
                        availableActions: r.availableActions || [], // New: Global actions if needed
                        // Legacy fields (if still in schema; remove if not)
                        excludedModules: r.excludedModules || [],
                        employees: r.employees || [],
                        roleId: r._id,
                    },
                ])
            );

            return roleMap;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data || err.message);
        }
    }
);

const rolePermissionsSlice = createSlice({
    name: 'rolePermissions',
    initialState: {
        entities: {}, // ✅ Normalized map by role.name
        loading: false,
        error: null,
    },
    reducers: {
        clearPermissions: (state) => {
            state.entities = {};
            state.error = null;
        },
    },
    extraReducers: (builder) =>
        builder
            .addCase(fetchRoles.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchRoles.fulfilled, (state, action) => {
                state.loading = false;
                state.entities = action.payload;
            })
            .addCase(fetchRoles.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            }),
});

export const { clearPermissions } = rolePermissionsSlice.actions;
export default rolePermissionsSlice.reducer;